import React from 'react';
import Particles from 'react-particles-js';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { isMobile } from 'react-device-detect';

const ParticleBackground = ({ theme }) => {
  return (
    <div
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        display: 'flex',
      }}
    >
      <Particles
        params={{
          fpsLimit: 60,
          particles: {
            number: {
              value: 75,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: theme.colors.primary,
            },
            shape: {
              type: 'circle',
              stroke: {
                width: 0,
                color: theme.colors.primary,
              },
              polygon: {
                nb_sides: 5,
              },
            },
            opacity: {
              value: 0.5,
              random: false,
              anim: {
                enable: false,
                speed: 0.5,
                opacity_min: 0.25,
                sync: true,
              },
            },
            size: {
              value: isMobile ? 5 : 6,
              random: true,
              anim: {
                enable: true,
                speed: 3,
                size_min: 1,
                sync: false,
              },
            },
            line_linked: {
              enable: true,
              distance: 100,
              color: theme.colors.primary,
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 1,
              direction: 'top',
              random: true,
              straight: false,
              out_mode: 'out',
              bounce: false,
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200,
              },
            },
          },
          interactivity: {
            detect_on: 'window',
            events: {
              onhover: {
                enable: !isMobile,
                mode: 'grab',
              },
              onclick: {
                enable: !isMobile,
                mode: 'push',
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 105,
                line_linked: {
                  opacity: 1,
                },
              },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3,
              },
              repulse: {
                distance: 100,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
              remove: {
                particles_nb: 2,
              },
            },
          },
          retina_detect: true,
        }}
      />
    </div>
  );
};

ParticleBackground.propTypes = {
  theme: PropTypes.object,
};

export default withTheme(ParticleBackground);
Particles;
